import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASEURL || 'http://localhost:8080/api';

// Existing api instance
export default axios.create({
  baseURL: BASE_URL,
});

// New axios instance with headers
export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const axiosCustom = axios.create({
  baseURL: BASE_URL,
});

// Interceptors
axiosPrivate.interceptors.request.use((config) => {
  const token = Cookies.get('token'); // Get token from cookies instead of localStorage
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

axiosPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if ((error.response && error.response.status === 403) || error.response.status === 401) {
      const { data } = error.response;
      if (data && data.error === 'token_expired') {
        Cookies.remove('token'); // Remove token from cookies instead of localStorage
      }
    }
    return Promise.reject(error);
  }
);